import SignUpWithPurchaseForm from './SignUpWithPurchaseForm';

export default SignUpWithPurchaseForm;
